export enum fundAssetClassFormFields {
  nameEn = 'nameEn',
  nameAr = 'nameAr',
  descriptionEn = 'descriptionEn',
  descriptionAr = 'descriptionAr',
  isEquity = 'isEquity',
}
